var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalTradesV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_10192_27182)",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5875 16.32V19.2H41.5306L37.5368 23.5931L34.7075 20.7638L26.7875 28.6838L23.9553 25.8516L15.0186 33.9741L16.9564 36.1059L23.8596 29.8284L26.7875 32.7563L34.7075 24.8363L37.6367 27.7655L43.3475 21.4852V24.96H46.2275V16.32H37.5875ZM41.9075 28.56V43.68H44.7875V28.56H41.9075ZM31.8275 30.72V43.68H34.7075V30.72H31.8275ZM36.8675 30.72V43.68H39.7475V30.72H36.8675ZM21.7475 34.32V43.68H24.6275V34.32H21.7475ZM26.7875 35.04V43.68H29.6675V35.04H26.7875ZM16.7075 37.92V43.68H19.5875V37.92H16.7075Z",
    fill: "#03F5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.907 28.56V43.68H44.787V28.56H41.907ZM31.827 30.72V43.68H34.707V30.72H31.827ZM36.867 30.72V43.68H39.747V30.72H36.867ZM21.747 34.32V43.68H24.627V34.32H21.747ZM26.787 35.04V43.68H29.667V35.04H26.787ZM16.707 37.92V43.68H19.587V37.92H16.707Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10192_27182",
    x1: 9.66699,
    y1: 2,
    x2: 60.667,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTradesV2);
export default __webpack_public_path__ + "static/media/totalTradesV2.811bbcd4cff791b88ff71368edf2cf45.svg";
export { ForwardRef as ReactComponent };